/** A farm's feeding slots by day of culture (#360), as GET /farms/{id}/feeding-schedule resolves them. */

export interface FeedingRange {
  from_doc: number;
  to_doc: number | null;
  slots: string[];
}

export interface FeedingSchedule {
  enabled: boolean;
  /** True when the ranges are the farm's own; false when they are derived from its list. */
  custom_ranges: boolean;
  ranges: FeedingRange[];
  /** The farm's one list: what every DOC uses when the schedule is off or has no range for it. */
  default_slots: string[];
  /** A one-click starting point for the owner's editor; applied to no farm by itself. */
  starting_preset?: FeedingRange[];
}

/** Slots that apply on a DOC. Null DOC (before stocking) and DOCs outside every range use the farm's list. */
export function slotsForDoc(schedule: FeedingSchedule | undefined, doc: number | null | undefined): string[] | undefined {
  if (!schedule) return undefined;
  if (schedule.enabled && doc !== null && doc !== undefined) {
    const range = schedule.ranges.find((r) => r.from_doc <= doc && (r.to_doc === null || doc <= r.to_doc));
    if (range) return range.slots;
  }
  return schedule.default_slots;
}
